import { DEFAULT_GOLD } from "../constant";

export const getNavItemStyles = (path: string, pathname: string) => {
  return {
    color: pathname === path ? DEFAULT_GOLD : "white",
    borderBottom: pathname === path ? `3px solid ${DEFAULT_GOLD}` : "none",
    marginRight: "10px",
  };
};
